export const DEFAULT_GENDER = 'men';

export const DEFAULT_TYPE = 'short_sleeves';

export const DEFAULT_SIZE = 'auto';

export const SVG_VIEWBOX = 656;
